import type { DocumentNode } from "graphql";
import { gql } from "@apollo/client";
import { ProductLevel } from "../../types/enums";

export const allProductsDatum = {
  productId: "all-products",
  nameShortEn: "All Products",
  nameEn: "All Products",
  productLevel: ProductLevel.AllProducts,
};

const query: DocumentNode = gql`
  query GetProducts($productClass: ProductClass!) {
    products: allProducts(productClass: $productClass) {
      id
      shortName
      level
      parent {
        id
        type: productType
      }
    }
  }
`;

export default query;
